import * as React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';
import {isEmpty} from 'lodash/fp';

import InlineFormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {styles} from '/component/partial/reportCard/ClientReportPopover/component/Volume/Volume.style';
import {getExpiringBeforeNextPremier} from '/component/partial/reportCard/ExpiringWellnessCreditsReportContent/ExpiringWellnessCreditsVolume/ExpiringWellnessCreditsVolume.util';
import {UserProfileModal} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import testProperties from '/util/testing/testProperties';
interface WellnessCreditsHistoryItem {
  amount: number;
  earnedOn: string;
  expiresOn: string;
}
interface ReportRecordData {
  scheduledOn?: string | null;
  wellnessCredits: {
    balance: number;
    currencyCode: string;
    history: WellnessCreditsHistoryItem[];
  };
}
interface Props {
  reportRecordData: ReportRecordData;
}

export const ExpiringWellnessCreditsVolume: React.FC<Props> = ({
  reportRecordData,
}) => {
  const {tt} = useTranslation('reportCardContent.expiringWellnessClients');
  const {
    scheduledOn,
    wellnessCredits: {balance, currencyCode, history},
  } = reportRecordData;

  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const premierValue = updatePremierPlus ? 'Premier+' : 'Premier';

  const expiringBeforeNextPremier = getExpiringBeforeNextPremier({
    scheduledOn,
    history,
  });
  return (
    // @ts-expect-error TS(2339): Property 'base' does not exist on type '{ footer: ... Remove this comment to see the full error message
    <View style={styles.base}>
      <View style={styles.footerRow} {...testProperties(null, true)}>
        <Text variant="button">
          {tt(
            'footer.ExpiringBeforeNextPremier.label',
            `Expiring Before Next ${premierValue}`,
          )}
        </Text>
        <InlineFormattedNumber
          testID={UserProfileModal.expiringBeforeNextPremier}
          textEmphasis="low"
          textVariant="button"
          // @ts-expect-error TS(2339): Property 'balance' does not exist on type '{ foote... Remove this comment to see the full error message
          style={styles.balance}
          value={expiringBeforeNextPremier}
          decimalPlaces={2}
          currencyCode={currencyCode}
        />
      </View>
      <View style={styles.footerRow} {...testProperties(null, true)}>
        <Text variant="button">
          {tt(
            'footer.nextScheduledPremier.label',
            `Next Scheduled ${premierValue}`,
          )}
        </Text>
        <Text emphasis="low" testID={UserProfileModal.nextScheduledPremier}>
          {isEmpty(scheduledOn)
            ? tt('nextScheduledPremier.na', 'N/A')
            : getDateUtilDefaultInstance().formatDate(
                scheduledOn,
                'MMM d, yyyy',
              )}
        </Text>
      </View>
      <View style={styles.footerRow} {...testProperties(null, true)}>
        <Text variant="button">
          {tt('footer.totalWellnessCredits.label', 'Total Wellness Credits')}
        </Text>
        <InlineFormattedNumber
          testID={UserProfileModal.totalWellnessCredits}
          textEmphasis="low"
          textVariant="button"
          // @ts-expect-error TS(2339): Property 'balance' does not exist on type '{ foote... Remove this comment to see the full error message
          style={styles.balance}
          value={balance}
          decimalPlaces={2}
          currencyCode={currencyCode}
        />
      </View>
    </View>
  );
};
